import { useEffect, useState } from "react";

const navLinks = [
  { href: "#entry", label: "免费版入口" },
  { href: "#features", label: "功能特点" },
  { href: "#comics", label: "热门漫画" },
  { href: "#compare", label: "版本对比" },
  { href: "#faq", label: "常见问题" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <nav
        className={`mx-auto flex h-16 md:h-[72px] max-w-page items-center justify-between px-4 md:px-6 transition-colors ${
          scrolled ? "text-foreground-900" : "text-background-50"
        }`}
      >
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-bug-line text-lg"></i>
          </span>
          <span className="font-heading text-xl tracking-wide">虫虫漫画</span>
        </a>

        <div className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="rounded-full px-4 py-2 text-sm font-medium transition-colors hover:bg-primary-500/15 hover:text-primary-500 whitespace-nowrap"
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="hidden md:block">
          <a
            href="#entry"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
          >
            免费版入口
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-full transition-colors hover:bg-primary-500/15 md:hidden"
        >
          <i className={open ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"}></i>
        </button>
      </nav>

      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 text-foreground-900">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setOpen(false)}
              className="block rounded-lg px-3 py-3 text-sm font-medium transition-colors hover:bg-primary-500/10"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#entry"
            onClick={() => setOpen(false)}
            className="mt-2 flex items-center justify-center gap-2 rounded-full bg-primary-500 px-5 py-3 text-sm font-bold text-background-50"
          >
            免费版入口
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      )}
    </header>
  );
}